#import "../../../../../common/graphql/NotesEntityFields.graphql"

query DocumentPoolNotes($id: UUID!) {
  documentPool(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
